<template>
    <div class="cultureCycleEdit" style="width:97.8%;border:1px solid #e0e0e0;margin-left:14px;">
      <div class="titleForm-container">{{edit?"编辑养殖周期":"查看养殖周期"}}</div>
      <div  class="content-form-container">
        <div class="main-container-form">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="ruleForm" >
            <el-form-item label="基地" prop="fishBaseName">
              <el-select v-model="ruleForm.fishBaseName" disabled placeholder="请选择" style="width:100%;" @change="getChangeFishPondNoBatch">
                 <el-option
                  v-for="(item, index) in baseList"
                  :key="index"
                  :label="item.value"
                  :value="item.key">
                 </el-option>
              </el-select>
            </el-form-item>
            <el-row  :gutter="3">
              <el-form-item label="塘口"  prop="fishPondName" required>        
                <el-col :span="18" :md="{span: 17}">
                  <el-form-item >
                    <el-select placeholder="请选择" disabled size="medium" style="width:100%;" v-model="ruleForm.fishPondName">
                      <el-option
                        v-for="(item, index) in fishPondNoBatch"
                        :key="index"
                        :label="item.fishPondName"
                        :value="item.fishPondId">
                      </el-option>
                    </el-select>
                  </el-form-item>  
                </el-col>
                <el-col :span="4" :md="{span: 5}" :offset="0.5" >
                  <el-form-item prop="batch">
                    <el-input disabled  v-model.number="ruleForm.batch" style="width:100%;" size="medium"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2" :offset="0.5">    
                  <span>批</span>
                </el-col>
              </el-form-item>   
            </el-row>
            <el-form-item label="开始时间"  value-format="yyyy-MM-dd" prop="startDate" >
              <el-col>
               <el-date-picker type="date" 
                placeholder="选择日期" 
                disabled 
                v-model="ruleForm.startDate" 
                style="width: 100%;" >
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="清塘时间"  value-format="yyyy-MM-dd"  prop="clearedDate">
              <el-col>
                <el-date-picker
                  type="date" 
                  :disabled="!edit"
                  v-model="ruleForm.clearedDate" 
                  :picker-options="clearPickerTimeOptions"
                  value-format="yyyy-MM-dd"
                   placeholder="选择日期" 
                  style="width:100%;">
                </el-date-picker>
              </el-col>
            </el-form-item>
            <el-form-item label="备注" prop="mark">
              <el-input v-model="ruleForm.mark"  :disabled="!edit" onKeypress="javascript:if(event.keyCode == 32)event.returnValue = false;" :maxlength="num50" placeholder="请输入备注" style="width:100%;"></el-input>
            </el-form-item>
            <el-form-item v-if="edit">
              <el-col :span="8" >
                <el-button  class="edit-save-btn" type="primary"   @click="editSubmitForm('ruleForm')" >保存</el-button>
              </el-col>
              <el-col :span="8">
                <el-button class="cancel-btn"  @click="cancelForm('ruleForm')">取消</el-button>
              </el-col>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { modules } from "../../../store";
import checkPermission from "../../../service/checkPermission.js";
export default {
  name: "cultureCycleEdit",
  data() {
    return {
      edit: this.$route.query.edit,
      id: this.$route.query.id,
      num50: 50,
      showLastBatch: false, // 弹框周期是否添+
      clearPickerTimeOptions: {
        // 限制日期
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6;
        }
      },
      baseList: [], //基地列表
      ruleForm: {
        fishBaseName: "",
        fishPondName: "",
        batch: "",
        startDate: "",
        clearedDate: "",
        mark: ""
      },
      rules: {
        fishBaseName: [
          { required: true, message: "请选择基地", trigger: "change" }
        ],
        fishPondName: [
          { required: true, message: "请选择塘口", trigger: "change" }
        ],
        batch: [
          {
            required: true,
            min: 1,
            max: 9999,
            pattern: /^[1-9]*$/,
            message: "批次格式有误",
            trigger: "blur"
          }
        ],
        startDate: [
          {
            required: true,
            message: "请选择开始时间",
            trigger: "change"
          }
        ],

        mark: [{ required: false, message: "请输入备注", trigger: "blur" }]
      }
    };
  },
  methods: {
    ...mapActions(modules.cultureCycle, [
      "getFishPondNoBatch", // 基地下已清塘的鱼塘
      "getEditFishBatchData", //编辑周期
      "editFishBatchData" //编辑-保存
    ]),
    ...mapActions(modules.base, [
      "getBaseList" //基地信息
    ]),
    // 获取基地改变时塘口的数据
    getChangeFishPondNoBatch() {
      this.ruleForm.fishPondName = "";
      this.ruleForm.batch = "";
      this.showLastBatch = false;
      if (this.ruleForm.fishBaseName !== this.baseList[0].key) {
        this.getFishPondNoBatch(this.ruleForm.fishBaseName)
          .then(rsp => {
            if (rsp.status === 200) {
              if (this.fishPondNoBatch[0]) {
                this.ruleForm.fishPondName = this.fishPondNoBatch[0].fishPondId;
                if (this.fishPondNoBatch[0].lastClearedDate === null) {
                  // 判断是否为清塘 如果最后时间为null则可自动填写批次
                  this.showLastBatch = false;
                  this.ruleForm.batch = "";
                } else {
                  // this.ruleForm.fishPondName.filter(f => f.this.ruleForm.batch);
                  this.ruleForm.batch = this.fishPondNoBatch[0].lastBatch + 1;
                  this.showLastBatch = true;
                }
              }
            }
          })
          .catch(err => {
            console.dir(err);
          });
      }
    },
    //获取当行数据
    getCurrData() {
      this.getEditFishBatchData(this.id)
        .then(rsp => {
          if (rsp.status === 200) {
            this.ruleForm = rsp.data || [];
            this.ruleForm.clearedDate = "";
          }
        })
        .catch(err => {
          console.dir(err);
        });
    },
    //编辑--保存
    editSubmitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let obj = {
            id: this.id, //行id
            fishPondName: this.ruleForm.fishPondName,
            batch: this.ruleForm.batch,
            startDate: this.ruleForm.startDate,
            clearedDate: this.ruleForm.clearedDate,
            remark: this.ruleForm.mark
          };
          this.editFishBatchData(obj)
            .then(rsp => {
              if (rsp.status === 200) {
                this.showDialog = false;
                this.$message({
                  message: "保存成功",
                  type: "success"
                });
                history.go(-1);
              }
            })
            .catch(err => {
              this.$Alert.info({
                content: err.response.data,
                duration: 5000,
                status: "error"
              });
              // this.$message.error(err.response.data);
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //取消
    cancelForm() {
      history.go(-1);
    }
  },
  async mounted() {
    this.getCurrData(); //当前行数据
    //获取基地
    let obj = {
      fishBaseName: this.fishBaseName
    };
    this.baseList = await this.getBaseList(obj);
  },
  computed: {
    ...mapState(modules.cultureCycle, ["fishPondNoBatch"])
  }
};
</script>

<style lang="" scoped>
    
</style>
